import { Center, Loader } from '@mantine/core'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/features/auth/model'

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    const authState = useAuthStore.getState()

    if (authState.isAuthenticated()) {
      throw redirect({
        to: '/dashboard',
        replace: true,
      })
    } else {
      throw redirect({
        to: '/login',
        replace: true,
      })
    }
  },
  component: MinimalRootComponent,
})

function MinimalRootComponent() {
  return (
    <Center style={{ height: '100vh' }}>
      <Loader />
    </Center>
  )
}
